import { c as _c } from "react/compiler-runtime";
import { useAuth } from "../../hooks/use-auth";
import SignInCard from "./SignInCard";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SignInView(t0) {
  const $ = _c(17);
  const {
    authClient,
    onSuccess,
    onRegister,
    onForgotPassword,
    statusMessage,
    onStatusMessageAction,
    signUpEnabled: t1
  } = t0;
  const signUpEnabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== authClient) {
    t2 = {
      authClient
    };
    $[0] = authClient;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    signIn,
    isUpdating,
    signInWithGoogle
  } = useAuth(t2);
  let t3;
  if ($[2] !== onSuccess || $[3] !== signIn) {
    t3 = async (email, password) => {
      const response = await signIn(email, password);
      if (response.success && onSuccess) {
        onSuccess();
      }
      return response;
    };
    $[2] = onSuccess;
    $[3] = signIn;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleLogin = t3;
  let t4;
  if ($[5] !== onSuccess || $[6] !== signInWithGoogle) {
    t4 = async () => {
      const response_0 = await signInWithGoogle();
      if (response_0.success && onSuccess) {
        onSuccess();
      }
      return response_0;
    };
    $[5] = onSuccess;
    $[6] = signInWithGoogle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleSignInWithGoogle = t4;
  let t5;
  if ($[8] !== handleLogin || $[9] !== handleSignInWithGoogle || $[10] !== isUpdating || $[11] !== onForgotPassword || $[12] !== onRegister || $[13] !== onStatusMessageAction || $[14] !== signUpEnabled || $[15] !== statusMessage) {
    t5 = /*#__PURE__*/_jsx(SignInCard, {
      handleLogin: handleLogin,
      onRegisterClick: onRegister,
      onForgotPasswordClick: onForgotPassword,
      statusMessage: statusMessage,
      onStatusMessageAction: onStatusMessageAction,
      isLoading: isUpdating,
      signUpEnabled: signUpEnabled,
      signInWithGoogle: handleSignInWithGoogle
    });
    $[8] = handleLogin;
    $[9] = handleSignInWithGoogle;
    $[10] = isUpdating;
    $[11] = onForgotPassword;
    $[12] = onRegister;
    $[13] = onStatusMessageAction;
    $[14] = signUpEnabled;
    $[15] = statusMessage;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}